var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.205174 14.3154C0.0819173 14.8818 0.516781 15.1216 0.920284 14.9407L14.5576 7.94796H14.559C14.7217 7.85621 14.8161 7.69088 14.8161 7.50016C14.8161 7.30933 14.7217 7.14388 14.559 7.05217H14.5576L0.920284 0.0593246C0.516781 -0.121612 0.0819173 0.118228 0.205174 0.684652C0.213514 0.723019 1.01974 4.31429 1.45809 6.26745L8.57701 7.50012L1.45809 8.73265C1.01974 10.6857 0.213477 14.277 0.205174 14.3154Z",
    fill: "#F79138"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3389,
    height: 14.3389,
    fill: "white",
    transform: "scale(1.04611)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.75a283015400caed1a45c7e9d3532022.svg";
export { ForwardRef as ReactComponent };